<div class = "label">
  <button class="edit-unit" (click)="editUnitNumberPopup(jobItem)">
        {{ action }} UNIT
  </button>
</div>